export default "__VITE_ASSET__b1e23b6e__"